var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTensorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.999 56.0508V69.1016L113.602 82.1523V69.1016L90.999 56.0508ZM45.792 69.1016V82.1523L57.0934 88.6764V75.6269L45.792 69.1016ZM79.6962 75.6269L68.3948 82.1523V121.302L79.6962 127.827V101.727L90.999 108.253V95.2018L79.6962 88.6764V75.6269Z",
    fill: "#E55B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9993 56.0508L57.0938 75.6269V88.6764L79.6966 75.6269V88.6764L90.9993 82.1523V56.0508ZM124.905 62.5762L113.602 69.1016V82.1523L124.905 75.6269V62.5762ZM102.301 88.6764L90.9993 95.2018V108.253L102.301 101.727V88.6764ZM90.9993 108.253L79.6966 101.727V127.827L90.9993 121.302V108.253Z",
    fill: "#ED8E24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.999 43L45.792 69.1002L57.0934 75.6256L90.999 56.0494L113.602 69.1002L124.905 62.5748L90.999 43ZM90.999 82.151L79.6962 88.675L90.999 95.2004L102.3 88.675L90.999 82.151Z",
    fill: "#F8BF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorImg);
export default __webpack_public_path__ + "static/media/tensorImg.af06caf02bf1354131f9149f346eb62e.svg";
export { ForwardRef as ReactComponent };